import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useStore } from '../../../hooks/useStore';
import { LogoutIcon } from '../../../lib/icons';

export const LogoutButton: FC = () => {
  const { t } = useTranslation('common');
  const { authenticationStore } = useStore();

  return (
    <MenuItem onClick={() => authenticationStore.logout()} className="px-6 py-4">
      <ListItemIcon>
        <LogoutIcon className="text-primary-main" />
      </ListItemIcon>
      <ListItemText primary={t('LOGOUT')} />
    </MenuItem>
  );
};
